import React from 'react'
import { Form, Tag, Space } from 'antd'

/**
 * A row of clickable {placeholder} chips. Clicking appends the token to the
 * string form field at `targetPath`.
 */
export function TokenChips({
  tokens,
  targetPath,
}: {
  tokens: string[]
  targetPath: (string | number)[]
}) {
  const form = Form.useFormInstance()
  if (tokens.length === 0) return null
  return (
    <Space size={4} wrap style={{ marginTop: 6 }}>
      {tokens.map((t) => (
        <Tag
          key={t}
          style={{ cursor: 'pointer', fontFamily: 'monospace' }}
          onClick={() => {
            const cur = (form.getFieldValue(targetPath) as string | undefined) ?? ''
            form.setFieldValue(targetPath, `${cur}${t}`)
          }}
        >
          {t}
        </Tag>
      ))}
    </Space>
  )
}
